<template>
  <v-fab-transition>
    <v-tooltip
      v-if="showScrollBottom"
      left
    >
      <v-btn
        slot="activator"
        fixed
        right
        fab
        dark
        small
        class="mb-3 btn-middle"
        color="white"
        @click="scrollBottom"
      >
        <v-icon
          :size="28"
          fab
          color="black"
        >
          keyboard_arrow_down
        </v-icon>
      </v-btn>
      <span>{{ $t('sheet.scroll_down') }}</span>
    </v-tooltip>
  </v-fab-transition>
</template>

<script>
export default {
    name: 'ScrollBottomButton',
    data () {
        return {
            showScrollBottom: true
        };
    },
    created () {
        window.addEventListener('scroll', this.scrollEvent);
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.scrollEvent);
    },
    methods: {
        scrollBottom () {
            if (!document.body) return;
            this.$vuetify.goTo(document.body.scrollHeight, {
                easing: 'easeInQuad'
            });
        },
        scrollEvent () {
            if (!document.body) return;

            this.showScrollBottom =
        window.pageYOffset + window.innerHeight <= document.body.scrollHeight - 250;
        }
    }
};
</script>

<style lang="scss" scoped>
.btn-middle {
  top: 50%;
  transform: translateY(-50%);
}
</style>
